<template>
  <v-card class="rounded-xl" :border="false" :elevation="0">
    <v-card-title class="d-flex justify-center align-center">
      <div class="switch-content">
        <v-btn
          class="button"
          variant="outlined"
          :class="{ selected: goTo }"
          v-model="goTo"
          @click="setSelected('goTo')"
        >
          {{ $t('TRANSPORTER_REPAIR_FILE.GO_TO') }}
        </v-btn>
        <v-btn
          class="button"
          variant="outlined"
          :class="{ selected: returnTo }"
          v-model="returnTo"
          @click="setSelected('returnTo')"
        >
          {{ $t('TRANSPORTER_REPAIR_FILE.RETURN_TO') }}
        </v-btn>
      </div>
    </v-card-title>

    <!-- GO bloc-->
    <v-row v-if="goTo" no-gutters class="mt-2 d-flex flex-column ga-4">
      <v-col cols="12">
        <section
          class="information-wrapper"
          v-if="
            currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER
          "
        >
          <p class="information-label black">
            {{ $t('TRANSPORTER_REPAIR_FILE.TRANSPORTER_GO') }}
          </p>
          <p>-</p>
        </section>

        <section class="information-wrapper grey">
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.ADDRESS_NAME') }}
          </p>
          <p class="information-content">
            {{ goToAddress.address_name ? goToAddress.address_name : '-' }}
          </p>
        </section>

        <section class="information-wrapper grey">
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.ADDRESS') }}
          </p>
          <p class="information-content">
            {{ goToAddress.address ? goToAddress.address : '-' }}
          </p>
        </section>

        <section class="information-wrapper grey">
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.CITY') }}
          </p>
          <p class="information-content">
            {{ goToAddress.city ? goToAddress.city : '-' }}
          </p>
        </section>

        <section
          class="information-wrapper grey"
          v-if="
            currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER
          "
        >
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.TRANSPORT_TYPE') }}
          </p>
          <p class="information-content">
            {{ $t('TRANSPORTER_REPAIR_FILE.TYPE.' + currentRepairFile.initial_transporter_type) }}
          </p>
        </section>

        <section
          class="information-wrapper grey"
          v-if="
            currentRepairFile.initial_transporter_type ===
              TransportTypeConstant.IMMEDIATE_TRANSPORTER &&
            currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER
          "
        >
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.TRANSPORTER') }}
          </p>
          <p class="information-content">
            {{
              currentRepairFile.initial_transporter_name
                ? currentRepairFile.initial_transporter_name
                : '-'
            }}
          </p>
        </section>

        <section
          class="information-wrapper grey"
          v-if="
            currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER
          "
        >
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.FINALIZATION_DATE') }}
          </p>
          <p class="information-content">
            {{
              currentRepairFile.finalization_date
                ? getFormattedDate(currentRepairFile.finalization_date)
                : '-'
            }}
          </p>
        </section>

        <section
          class="information-wrapper grey"
          v-if="currentRepairFile.with_collect !== undefined"
        >
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.COLLECT_STATUS') }}
          </p>
          <p class="information-content">
            {{
              currentRepairFile?.with_collect === true
                ? $t('COMMON.BUTTON.YES')
                : $t('COMMON.BUTTON.NO')
            }}
          </p>
        </section>

        <!--TODO add date of expedition-->
        <section
          class="information-wrapper grey"
          v-if="
            currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER
          "
        >
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.EXPEDITION_DATE') }}
          </p>
          <p class="information-content">-</p>
        </section>

        <section
          class="information-wrapper grey"
          v-if="
            currentRepairFile.initial_transporter_modality === TransportModalityConstant.TRANSPORTER
          "
        >
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.TRACKING_NUMBER') }}
          </p>
          <p class="information-content">
            {{ currentRepairFile.tracking_number ? currentRepairFile.tracking_number : '-' }}
          </p>
        </section>

        <section
          class="information-wrapper grey"
          v-if="
            currentRepairFile.initial_transporter_modality ===
              TransportModalityConstant.TRANSPORTER &&
            checkPermission(['DISTRIBUTOR_TRANSPORTER_READ_PERMISSION'])
          "
        >
          <p class="information-label green">
            {{ $t('TRANSPORTER_REPAIR_FILE.TRANSPORTER_LOGIN') }}
          </p>
          <p class="information-content green">
            {{
              currentExpressistLink?.connexion.login ? currentExpressistLink?.connexion.login : '-'
            }}
          </p>
        </section>
      </v-col>
    </v-row>

    <!--RETURN bloc-->
    <v-row v-if="returnTo" no-gutters class="mt-2 d-flex flex-column ga-4">
      <v-col cols="12">
        <section class="information-wrapper grey">
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.ADDRESS_NAME') }}
          </p>
          <p class="information-content">
            {{ returnToAddress.address_name ? returnToAddress.address_name : '-' }}
          </p>
        </section>

        <section class="information-wrapper grey">
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.ADDRESS') }}
          </p>
          <p class="information-content">
            {{ returnToAddress.address ? returnToAddress.address : '-' }}
          </p>
        </section>

        <section class="information-wrapper grey">
          <p class="information-label">
            {{ $t('TRANSPORTER_REPAIR_FILE.CITY') }}
          </p>
          <p class="information-content">
            {{ returnToAddress.city ? returnToAddress.city : '-' }}
          </p>
        </section>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import TransportModalityConstant from '@/constants/transportModalityConstant'
import TransportTypeConstant from '@/constants/transportTypeConstant'
import DeliveryAddressTypeConstant from '@/constants/deliveryAddressTypeConstant'
import { RepairFile } from '@/models/RepairFile'
import ExpressistTransporterService from '@/services/transporters/ExpressistTransporterService'
import { checkPermission } from '@/components/utils/globalFunction'

export default {
  name: 'TransporterRepairFile',
  props: {
    currentRepairFile: RepairFile
  },
  computed: {
    TransportTypeConstant() {
      return TransportTypeConstant
    },
    TransportModalityConstant() {
      return TransportModalityConstant
    }
  },
  data() {
    return {
      goTo: true,
      returnTo: false,

      goToAddress: [],
      returnToAddress: [],

      currentExpressistLink: null
    }
  },
  async mounted() {
    this.patchAddress()

    if (
      this.currentRepairFile.initial_expressist_transporter_connexion_link_id !== null &&
      checkPermission(['ADMIN_TRANSPORTER_READ_PERMISSION'])
    ) {
      this.currentExpressistLink =
        await ExpressistTransporterService.getExpressistTransporterConnexionLoginByLinkId(
          this.currentRepairFile.initial_expressist_transporter_connexion_link_id
        )
    }
  },
  methods: {
    checkPermission,
    setSelected(selected) {
      if (selected === 'goTo') {
        this.goTo = true
        this.returnTo = false
      } else if (selected === 'returnTo') {
        this.goTo = false
        this.returnTo = true
      }
    },
    patchAddress() {
      const delivery = this.currentRepairFile.delivery_address_list.find((address) => {
        return address.type === DeliveryAddressTypeConstant.DEPARTURE
      })
      if (delivery) {
        this.goToAddress.address_name = delivery.address_name
        this.goToAddress.address = delivery.address_number + ' ' + delivery.address_street
        this.goToAddress.city = delivery.address_zip_code + ' ' + delivery.address_city
      }
      const returnDelivery = this.currentRepairFile.delivery_address_list.find((address) => {
        return address.type === DeliveryAddressTypeConstant.RETURN
      })
      if (returnDelivery) {
        this.returnToAddress.address_name = returnDelivery.address_name
        this.returnToAddress.address =
          returnDelivery.address_number + ' ' + returnDelivery.address_street
        this.returnToAddress.city =
          returnDelivery.address_zip_code + ' ' + returnDelivery.address_city
      }
    },
    getFormattedDate(date) {
      return new Date(date).toLocaleDateString()
    }
  }
}
</script>

<style scoped>
.v-card {
  padding: 20px;
}

.switch-content {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 10px 20px;
  border-radius: 100px;
  background: #efefef;
}

.button {
  display: flex;
  align-items: center;
  border-radius: 50px;
  color: #000;
  text-align: center;

  font-size: 14px;
  font-weight: 600;
  border: unset;
  text-transform: unset;
}

.button.selected {
  background-color: white;
}

.grey {
  color: #acacac;
}

.green {
  color: #559a1b;
}

.black {
  font-weight: 700;
}

.information-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 2px;
}

.information-label,
.information-content {
  font-size: 13px;
  font-style: normal;
  line-height: 20px;
}

.information-content {
  font-weight: 600;
}
</style>
